// src/components/runs/DeleteRunDialog.jsx
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useTheme } from '../../theme/ThemeContext';

const DeleteRunDialog = ({ run, deleting, onCancel, onConfirm }) => {
  const { theme } = useTheme();

  if (!run) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-slate-900/50"
        onClick={() => !deleting && onCancel()}
      />

      {/* Dialog */}
      <div className="relative z-10 w-full max-w-sm rounded-2xl bg-white p-4 shadow-xl border border-slate-200">
        <div className="flex items-start gap-3">
          <div className="mt-1 flex h-8 w-8 items-center justify-center rounded-full bg-rose-50">
            <AlertTriangle className="h-4 w-4 text-rose-600" />
          </div>
          <div>
            <h2 className="text-sm font-semibold text-slate-900">
              Cancel this run?
            </h2>
            <p className="mt-1 text-xs text-slate-600">
              This will mark the run as{' '}
              <span className="font-semibold">cancelled</span>. Guards will not see
              it as an active run.
            </p>
            <p className="mt-2 text-xs text-slate-700">
              <span className="font-semibold">Run:</span>{' '}
              {run.title || 'Untitled'} ({run.run_date})
            </p>
          </div>
        </div>

        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            disabled={deleting}
            onClick={onCancel}
            className="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-50 disabled:opacity-50"
          >
            Keep Run
          </button>
          <button
            type="button"
            disabled={deleting}
            onClick={onConfirm}
            className="rounded-lg px-3 py-1.5 text-xs font-medium text-white disabled:opacity-50 bg-rose-600 hover:bg-rose-700 shadow-sm"
          >
            {deleting ? 'Cancelling...' : 'Cancel Run'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteRunDialog;
